<script>
    import PageHeader from '$components/PageHeader.svelte';
    import SEO from '$components/SEO.svelte';
    import {IconStarFilled} from '@tabler/icons-svelte';

    export let data;

    let { locality, subLocalities, subLocalityScores } = data;
    let titleCaseLocality;
    let subLocalityScoresMap = {};

    $: ({ locality, subLocalities, subLocalityScores } = data);
    $: titleCaseLocality = locality.charAt(0).toUpperCase() + locality.slice(1);
    $: {
        subLocalityScoresMap = {};
        subLocalityScores.forEach((subLocalityScore) => {
            subLocalityScoresMap[subLocalityScore.sub_locality_id] = {
                score: subLocalityScore.score,
                count: subLocalityScore.count,
            };
        });
    }

    const blurbs = {
        downtown:
            'Toronto\'s business hub, known for the iconic CN Tower, offers shopping, entertainment, and cultural attractions.',
        etobicoke:
            'Suburban district with green spaces like James Gardens; known for its diverse communities.',
        'east-end':
            'Known for the Beaches neighborhood, offering sandy shores and vibrant street festivals.',
        'midtown':
            'Upscale area with Yonge Street shops, home to the historic Casa Loma castle..',
        'west-end':
            'Known for its artistic communities, unique boutiques, and cultural diversity, offering a vibrant urban experience.',
        scarborough:
            'A multicultural area with natural attractions like the Scarborough Bluffs, providing recreational opportunities and diverse dining.',
        'east-york':
            'Once a separate city, known for its tight-knit community, strong local traditions, and access to the Don River Valley.',
        'north-york':
            'Diverse suburbs, home to the Toronto Centre for the Arts and Yorkdale Shopping Centre.',
        'york-crosstown':
            'Transportation corridor, notable for the Eglinton Crosstown LRT and various cultural pockets.',
    };
</script>

<SEO title='CondoGenius - {titleCaseLocality} Building Directory | Condo Reviews for Toronto and GTA'
     description='Find authentic, real-life reviews of condo buildings in {titleCaseLocality}.' />

<div class='flex flex-col items-start w-full text-left' data-sveltekit-preload-data='tap'>
    <PageHeader class='text-3xl font-heading-token' text={`${titleCaseLocality} Building Directory`} />
    <div class='grid gap-1 md:gap-4 grid-cols-1 grid-rows-3 sm:grid-cols-2 md:grid-cols-3'>
        {#each subLocalities as sub_locality}
            <a href='/buildings/{locality}/{sub_locality.slug}-n{sub_locality.id}'>
                <div
                    class='card card-hover mx-auto w-full md:mb-3 pb-3 px-5 hover:transform-none hover:z-20 hover:bg-white hover:shadow-2xl flex flex-col duration-50 h-full md:min-h-[260px] justify-between rounded-xl'
                >
                    <section class='flex flex-col h-full items-start'>
                        <div class='card-header my-3'>
                            <strong class='text-xl font-heading-token'>{sub_locality.name}</strong>
                        </div>
                        <p class='px-4 text-neutral-500 mt-5'>
                            {blurbs[sub_locality.slug]}
                        </p>
                    </section>

                    <section class='px-4 text-sm mt-5 md:mt-0 flex flex-row justify-evenly'>
                        <div class='flex flex-col text-center'>
                            <span class='font-bold text-2xl'>{sub_locality.building_count}</span>
                            <span class='text-neutral-500'>buildings</span>
                        </div>
                        <div class='flex flex-col text-center'>
                            {#if (subLocalityScoresMap[sub_locality.id.toString()]?.score || 0) > 0}
                                <span class='text-2xl flex flex-row items-center gap-1'>
                                {#if (subLocalityScoresMap[sub_locality.id.toString()]?.score || 0) >= 4.0}
                                    {(subLocalityScoresMap[sub_locality.id.toString()]?.score || 0).toFixed(1)}
                                    <IconStarFilled size={24} class='inline-block text-green-300'
                                                    color='text-green-300' />
                                {:else if (subLocalityScoresMap[sub_locality.id.toString()]?.score || 0) > 3}
                                    {(subLocalityScoresMap[sub_locality.id.toString()]?.score || 0).toFixed(1)}
                                    <IconStarFilled size={24} class='inline-block text-orange-300'
                                                    color='text-orange-300' />
                                {:else}
                                    {(subLocalityScoresMap[sub_locality.id.toString()]?.score || 0).toFixed(1)}
                                    <IconStarFilled size={24} class='inline-block text-red-300' />
                                {/if}
                                </span>
                                <span class='text-neutral-500'>
                                    {#if (subLocalityScoresMap[sub_locality.id.toString()]?.count || 0) === 1}
                                        {subLocalityScoresMap[sub_locality.id.toString()]?.count || 0} review
                                    {:else}
                                        {subLocalityScoresMap[sub_locality.id.toString()]?.count || 0} reviews
                                    {/if}
                                </span>
                            {:else}
                                &nbsp;
                            {/if}
                        </div>
                    </section>
                </div>
            </a>
        {/each}
    </div>
</div>

<style>
    .grid a {
        grid-auto-rows: 1fr;
    }
</style>
